import { convertPdfToImages } from "./ConvertPdfToImg";

const getDocumentLanguage = () =>
  localStorage.getItem("currentLang") ||
  document.documentElement.getAttribute("lang") ||
  "en";

export const handlePrintData = async (
  htmlContent,
  fileName = "document",
  pdfBase64,
  prepareDocument
) => {
  let pdfImages = [];
  if (pdfBase64) {
    pdfImages = await convertPdfToImages(pdfBase64);
  }

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.left = "-10000px";
  iframe.style.width = "210mm";
  iframe.style.height = "297mm";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow.document;
  const lang = getDocumentLanguage();
  const dir = lang === "ar" ? "rtl" : "ltr";
  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html lang="${lang}" dir="${dir}">
      <head>
        <meta charset="utf-8" />
        <script src="https://cdn.tailwindcss.com"></script>
        <title>${fileName}</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100..900;1,100..900&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@100;200;300;400;500;600;700&display=swap');
          html[dir='rtl'] body { font-family: 'IBM Plex Sans Arabic', 'Segoe UI', Arial, sans-serif; }
          html[dir='ltr'] body { font-family: Archivo, Inter, Arial, sans-serif; }
          body { margin: 0; padding: 0; }
          img { max-width: 100%; margin: 10px 0; }
          @media print {
            @page { 
              size: A4; 
              margin: 0; 
            }
            body { 
              margin: 0 !important; 
              padding: 0 !important;
            }
          }
        </style>
      </head>
      <body>
        ${htmlContent}
         ${pdfImages?.length > 0
      ? pdfImages?.map((src) => `<img src="${src}" />`).join("")
      : ""
    }
      </body>
    </html>
  `);
  await new Promise((resolve, reject) => {
    let started = false;
    iframe.onload = async () => {
      if (started || !doc.body?.innerHTML.trim()) return;
      started = true;
      try {
        await Promise.race([
          doc.fonts?.ready || Promise.resolve(),
          new Promise(done => setTimeout(done, 10000))
        ]);
        await Promise.race([
          Promise.all(Array.from(doc.images).map(image =>
            image.complete ? Promise.resolve() : new Promise(done => {
              image.onload = done;
              image.onerror = done;
            })
          )),
          new Promise(done => setTimeout(done, 10000))
        ]);
        if (prepareDocument) await prepareDocument(doc);
        iframe.contentWindow.addEventListener('afterprint', () => iframe.remove(), { once: true });
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        resolve();
      } catch (error) {
        iframe.remove();
        reject(error);
      }
    };
    doc.close();
  });
};

export const openImage = (base64Data) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: "image/png" });
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
};
